import '../../css/style.scss'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {UICheckoutPageController} from '../../../shared/scripts/ui_checkout/UICheckoutPageController'

void init()

async function init() {
    EntryShared.initializeAudio()
    await EntryShared.initializeEntry()
    new UICheckoutPageController()
    EntryShared.sendPageVisitAnalyticEvent()
}
